import React from 'react';
import { Show } from '@refinedev/antd';
import { useShow } from '@refinedev/core';
import { Tag, theme } from 'antd';
import { Field } from '../../components/Field';
import { BodyMetricSourceType } from '@wellverse/shared-ts';
import type { DeviceSourceDto } from '@wellverse/shared-ts';

const sourceColors: Record<BodyMetricSourceType, string> = {
  [BodyMetricSourceType.MANUAL]: '#898989',
  [BodyMetricSourceType.APPLE_HEALTH]: '#52c41a',
  [BodyMetricSourceType.GOOGLE_FIT]: '#1890ff',
  [BodyMetricSourceType.GARMIN]: '#007cc3',
  [BodyMetricSourceType.FITBIT]: '#00b0b9',
  [BodyMetricSourceType.SAMSUNG_HEALTH]: '#1428a0',
  [BodyMetricSourceType.WITHINGS]: '#4bc9c0',
  [BodyMetricSourceType.XIAOMI]: '#ff6900',
  [BodyMetricSourceType.RENPHO]: '#7b2cbf',
  [BodyMetricSourceType.OPPO]: '#6b2737',
  [BodyMetricSourceType.HUAWEI_HEALTH]: '#cf222e',
  [BodyMetricSourceType.APPLE_WATCH]: '#000000',
  [BodyMetricSourceType.GARMIN_WATCH]: '#007cc3',
  [BodyMetricSourceType.POLAR]: '#6b4c9a',
  [BodyMetricSourceType.OTHER]: '#595959',
};

const tagStyle = (color: string) => ({
  borderColor: color,
  color,
  background: `${color}15`,
  borderRadius: 9999,
  padding: '2px 12px',
  fontWeight: 500,
});

export const BodyMetricSourceShow: React.FC = () => {
  const { token } = theme.useToken();
  const { queryResult } = useShow<DeviceSourceDto>({ resource: 'body-metric-admin/sources' });
  const item = queryResult?.data?.data;

  if (!item) {
    return <div style={{ color: token.colorTextSecondary }}>Loading...</div>;
  }

  return (
    <Show resource="body-metric-admin/sources">
      <div style={{ padding: '8px 0' }}>
        <Field label="ID">{item.id}</Field>
        <Field label="User ID">{item.userId}</Field>
        <Field label="Source Type">
          <Tag style={tagStyle(sourceColors[item.sourceType] || '#898989')}>{item.sourceType}</Tag>
        </Field>
        <Field label="Name">{item.name}</Field>
        {item.deviceId && <Field label="Device ID">{item.deviceId}</Field>}
        {item.lastSyncedAt && (
          <Field label="Last Synced At">{new Date(item.lastSyncedAt).toLocaleString()}</Field>
        )}
        <Field label="Active">
          <Tag style={tagStyle(item.isActive ? '#3ecf8e' : '#898989')}>
            {item.isActive ? 'Yes' : 'No'}
          </Tag>
        </Field>
        {item.metadata && (
          <Field label="Metadata">
            <pre style={{ background: token.colorFillAlter, padding: 8, borderRadius: 4, overflow: 'auto' }}>
              {JSON.stringify(item.metadata, null, 2)}
            </pre>
          </Field>
        )}
        <Field label="Created At">{new Date(item.createdAt).toLocaleString()}</Field>
        <Field label="Updated At">{new Date(item.updatedAt).toLocaleString()}</Field>
      </div>
    </Show>
  );
};